export const DELETE_SUCCESS = 'Пользователь удален';
export const DELETE_ERROR = 'Не удалось удалить пользователя';
